/**
 * Returns true when the active element is a text input, textarea, select, or
 * other editable control. Used to avoid hijacking arrow-key shortcuts while the
 * user is typing or interacting with a dropdown.
 */
export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
    return true;
  }
  return target.isContentEditable;
}

/**
 * Returns true when a popup that owns the keyboard is open — a MUI date-picker
 * popper or any element flagged as a dialog. Page-level arrow shortcuts should
 * stand down so the popup (e.g. the calendar) keeps the arrow keys to itself.
 */
export function isBlockingOverlayOpen(): boolean {
  return !!document.querySelector(
    '.MuiPickersPopper-root, .MuiDialog-root, [role="dialog"], [aria-modal="true"]',
  );
}
